
export const Hide = ({ condition = true, children }) => {
    const shouldHide =
        typeof condition === "function" ? condition() : condition;
    return shouldHide ? null : children;
};

export default Hide;
